import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal } from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import {
  getCategary,
  getIndustry,
  getLanguage,
  getPenalty,
  getSkills,
} from "../../../../redux/categary/action";
import ModalTitle from "../UpdateModels/ModalTitle";
import ModelCategory from "../UpdateModels/ModelCategory";
import ModelSubCategory from "../UpdateModels/ModelSubCategory";
import ModalDescription from "../UpdateModels/ModalDescription";
import ModelDuretion from "../UpdateModels/ModelDuretion";
import ModelBudget from "../UpdateModels/ModelBudget";
import ModelLanguage from "../UpdateModels/ModelLanguage";
import ModelDeliverables from "../UpdateModels/ModelDeliverables";
import ModelFile from "../UpdateModels/ModelFile";
import ModelMilestones from "../UpdateModels/ModelMilestones";
import ModelType from "../UpdateModels/ModelType";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import ModelWorkHiringType from "../UpdateModels/ModelWorkHiringType";
import { getUserProfile, HireExpert } from "../../../../redux/hire/action";
import ModelCountry from "../UpdateModels/ModelCountry";
import ModalCity from "../UpdateModels/ModalCity";
import { GetCountry } from "../../../../redux/master/action";
import { formatNumberWithCommas } from "../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import ModalIndustry from "../UpdateModels/ModalIndustry";
import { descriptionvalidation, filesvalidationforstatusbase, titlevalidation } from "../../../Common/commonvalidation";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";

const UpdateHireExpertJobDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { userinfo } = state;
  console.log(userinfo, 'userinfo');
  

  const [formData, setFormData] = useState({
    id: "",
    title: "",
    price: "",
    type: 1 || "",
    industry_index: "",
    industry_id: "",
    industry_title: "",
    is_ambrella: "0",
    ambrella_title: "",
    parent_id: "0",
    category_id: "0",
    sub_category_id: "0",
    description: "",
    duration_type: "0",
    duration: "0",
    deliverables: "",
    language_id: "0",
    last_date: "",
    hiring_type: "0",
    work_location: "0",
    country_id: "0",
    city_name: "",
    skills: [],
    milestones: "",
    amount: "",
    penalty: "",
    files: [],
    languageindex: "",
    category_index: "",
    subcategory_index: "",
    country_index: "",
    city_name: "",
    working_country: "",
  });
  const getuserprofile = useSelector(
    ({ hire: { getuserprofile } }) => getuserprofile
  );

  //

  useEffect(() => {
    if (userinfo) {
      setFormData({
        industry_id: userinfo.industry_id,
        industry_index: userinfo.industry_index,
        id: userinfo.id,
        industry_title: userinfo.industry_title,
        title: userinfo.title,
        price: userinfo.price,
        type: userinfo.type,
        is_ambrella: userinfo.is_ambrella,
        ambrella_title: userinfo.ambrella_title,
        parent_id: userinfo.parent_id,
        category_id: userinfo.category_id,
        sub_category_id: userinfo.sub_category_id,
        description: userinfo.description,
        duration_type: userinfo.duration_type,
        duration: userinfo.duration,
        deliverables: userinfo.deliverables,
        language_id: userinfo.language_id,
        last_date: userinfo.last_date,
        hiring_type: userinfo.hiring_type,
        work_location: userinfo.work_location,
        country_id: userinfo.country_id,
        city_name: userinfo.city_name,
        milestones: userinfo.milestones,
        amount: userinfo.amount,
        penalty: userinfo.penalty,
        files: userinfo.files,
        languageindex: userinfo.language_index,
        category_index: userinfo.category_index,
        subcategory_index: userinfo.subcategory_index,
        skills: getuserprofile?.skills,
        country_index: userinfo?.working_country_index,
        city_name: userinfo?.city,
      });
      setTitle(userinfo.title);
      setDescription(userinfo.description);
      setProjectbudget(userinfo.price);
      setExpecteddeliverables(userinfo.deliverables);
      setCategory(userinfo.category_index);
      setSubCategory(userinfo.subcategory_index);
    }
  }, [userinfo]);

  useEffect(() => {
    dispatch(getUserProfile(id));
  }, [id]);

  useEffect(() => {
    if (getuserprofile?.skills) {
      setFormData((pre) => ({ ...pre, skills: getuserprofile?.skills }));
    }
  }, [getuserprofile]);

  const [cityname, setCityname] = useState(formData.title);
  const [modaltitle, setModaltitle] = useState(false);
  const [title, setTitle] = useState(formData.title);
  const [modalcategory, setModalCategory] = useState(false);
  const [category, setCategory] = useState(formData.category_index);
  const [subcategory, setSubCategory] = useState(formData.subcategory_index);
  const [modalsubcategory, setModalSubCategory] = useState(false);
  const [modaldescription, setModalDescription] = useState(false);
  const [description, setDescription] = useState(formData.description);
  const [modalduretion, setModalduretion] = useState(false);
  const [duration, setProjectduration] = useState(formData.duration);
  const [modalBudget, setModalBudget] = useState(false);
  const [price, setProjectbudget] = useState(formData.price);
  const [modalLanguage, setModalLanguege] = useState(false);
  const [language_id, setLanguege] = useState(formData.language_id);
  const [modaldeliverables, setModaldeliverables] = useState(false);
  const [deliverables, setExpecteddeliverables] = useState(
    formData.deliverables
  );
  const [modalfile, setModalFile] = useState(false);
  // const [modalSkills, setModalSkills] = useState(false);
  const [modalMils, setModalMils] = useState(false);
  const [modaltype, setModaltype] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [modalhiringtype, setModalhiringtype] = useState(false);
  const [modalcountry, setModalcountry] = useState(false);
  const [modalcity, setModalcity] = useState(false);
  const [industryEditModal, setIndustryEditModal] = useState(false);

  useEffect(() => {
    // dispatch(getuserinfoById(id));
    dispatch(GetCountry());
    dispatch(getCategary());
    dispatch(getSkills());
    dispatch(getLanguage());
    dispatch(getPenalty());
    // dispatch(getIndustry());
    LoadCSSforfirstTime("Assets/scss/postproject.module.scss");
  }, [id, dispatch]);

  useEffect(() => {
    setCategory(formData?.category_index);
  }, [formData]);

  useEffect(() => {
    setSubCategory(formData?.subcategory_index);
  }, [formData?.subcategory_index]);

  const hitApi = () => {
    const data = {
      ...formData,
      title: title,
      description: description,
      price: price,
      deliverables: deliverables,
      city_name: cityname,
    };
    setFormData(data);
  };

  const handleSubmit = (values) => {
    const data = {
      ...values,
      type: "4",
      expert_id: id,
      lan: lan,
    };
    dispatch(HireExpert(data, navigate));
  };

  const validationSchema = Yup.object().shape({
    hiring_type: Yup.string().required("This is required"),
    title: titlevalidation,
    category_id: Yup.string().required("This is required"),
    // sub_category_id: Yup.string().required('This is required'),
    price: Yup.string().required("This is required"),
    description: descriptionvalidation,
    work_location: Yup.string().required("This is required"),
    working_country:
      formData?.working_country == ""
        ? Yup.string().required("This is required")
        : "",
    city_name: cityname == "" ? Yup.string().required("This is required") : "",
    language_id: Yup.string().required("This is required"),
     files: filesvalidationforstatusbase,
  }); 
  

  const handleInputTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleInputDescription = (e) => {
    setDescription(e.target.value);
  };
  const handleInputDuretion = (e) => {
    setProjectduration(e.target.value);
  };
  const handleInputBudget = (e) => {
    setProjectbudget(e.target.value);
  };
  const handleInputExpecteddeliverables = (e) => {
    setExpecteddeliverables(e.target.value);
  };
  const handleCityInputTitle = (e) => {
    setCityname(e.target.value);
  };

  const visitProfile = () => {
    const url = `${process.env.PUBLIC_URL}/${lan}/expertsprofiledetails/${id}`;
    window.open(url, "_blank"); // Open in a new tab
  };

  console.log(userinfo, 'userinfo');
  console.log(formData, 'formData');
  
  return (
    <div className="bg-project projectyou-details">
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {(formik) => (
          <Form>
            <div>
              <div className="col-lg-10   mx-auto project-det">
                <div className="project-first">
                  <h4>Job Details</h4>
                  <button type="submit" onClick={formik.handleSubmit} className="buttons background-button">
                    Send invite
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                      alt=""
                    />
                  </button>
                </div>
                <div className="project-row">
                  <div className="project-section">
                    <div>
                      <p>Hiring Type</p>
                      <h4>
                        {formData?.hiring_type == 1
                          ? "Hourly"
                          : formData?.hiring_type == 3
                            ? "Weekly"
                            : formData?.hiring_type == 4
                              ? "Monthly"
                              : ""}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalhiringtype(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="hiring_type"
                    component="div"
                    className="error"
                  />

                  <div className="project-section align-items-center">
                    <div>
                      <p>Expert info</p>
                      <div className="expert-left">
                        {/* <img src={getuserprofile?.profile_image} alt="" /> */}
                        <ProfileImageWithFallback url={getuserprofile?.profile_image} className="" />
                        <div>
                          <h2 className="manage-head">
                            {getuserprofile?.first_name}&nbsp;
                            {getuserprofile?.last_name}
                          </h2>
                          <h6>
                            {getuserprofile?.expert
                              ? getuserprofile?.expert?.designation
                              : ""}
                            {getuserprofile?.company
                              ? getuserprofile?.company?.cr_number
                              : ""}
                            <span>
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                                alt=""
                              />
                              {getuserprofile?.country_title}
                            </span>
                          </h6>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => visitProfile()}
                      className="buttons border-button"
                    >
                      Visit profile
                    </button>
                  </div>
                  <ErrorMessage
                    name="hiring_type"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Job Title</p>
                      <h4>{formData.title}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModaltitle(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Industry</p>
                      <h4>{formData?.industry_title || formData?.industry_index?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setIndustryEditModal(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="category_id"
                    component="div"
                    className="error"
                  />
                  <div className="project-section">
                    <div>
                      <p>Category</p>
                      <h4>{category?.title || category?.label || formData?.category_index?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Sub-Category</p>
                      <h4>{subcategory?.title || subcategory?.label || formData?.subcategory_index?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalSubCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="sub_category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Description</p>
                      <CustomReactQuillDescription
                        value={formData?.description}
                      />
                    </div>
                    <span
                      onClick={() => {
                        setModalDescription(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="description"
                    component="div"
                    className="error"
                  />

                  <ErrorMessage
                    name="skills"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Price</p>
                      <h4>
                        {formData?.price && "SAR "}
                        {formatNumberWithCommas(formData?.price)} /{" "}
                        {formData?.hiring_type == 1
                          ? "Hourly"
                          : formData?.hiring_type == 3
                            ? "Weekly"
                            : formData?.hiring_type == 4
                              ? "Monthly"
                              : ""}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalBudget(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="price"
                    component="div"
                    className="error"
                  />

                  <ErrorMessage
                    name="duration_type"
                    component="div"
                    className="error"
                  />
                  <ErrorMessage
                    name="duration"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div className="w-100">
                      <p>Attachments</p>
                      <div className="images image-row1 row">
                        {formData.files &&
                          Array.isArray(formData.files) &&
                          formData.files.map((item, index) => {
                            return (
                              <div className="col-md-4" key={index}>
                                <DisplayFileProper item={item} />
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <span
                      onClick={() => {
                        setModalFile(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="files"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Preferred Language of Work Submission</p>
                      <h4>
                        {formData?.languageindex?.label ||
                          formData?.languageindex}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalLanguege(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="language_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Country</p>
                      <h4>{formData?.country_index?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalcountry(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="country_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>City</p>
                      <h4>{formData?.city_name}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalcity(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="city_name"
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <Modal
                className="popupmodal"
                isOpen={modaltitle}
                toggle={() => setModaltitle((state) => !state)}
              >
                <ModalTitle
                  title={title}
                  setModaltitle={setModaltitle}
                  handleInputTitle={handleInputTitle}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalcategory}
                toggle={() => setModalCategory((state) => !state)}
              >
                <ModelCategory
                  formData={formData}
                  setFormData={setFormData}
                  category={category}
                  setSubCategory={setSubCategory}
                  setModalCategory={setModalCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalsubcategory}
                toggle={() => setModalSubCategory((state) => !state)}
              >
                <ModelSubCategory
                  parentid={formData.category_id}
                  formData={formData}
                  setFormData={setFormData}
                  setModalSubCategory={setModalSubCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaldescription}
                toggle={() => setModalDescription((state) => !state)}
              >
                <ModalDescription
                  setFormData={setFormData}
                  description={description}
                  setModalDescription={setModalDescription}
                  handleInputDescription={handleInputDescription}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalduretion}
                toggle={() => setModalduretion((state) => !state)}
              >
                <ModelDuretion
                  formData={formData}
                  setFormData={setFormData}
                  duration={duration}
                  setModalduretion={setModalduretion}
                  handleInputDuretion={handleInputDuretion}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalBudget}
                toggle={() => setModalBudget((state) => !state)}
              >
                <ModelBudget
                  price={price}
                  setModalBudget={setModalBudget}
                  handleInputBudget={handleInputBudget}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalLanguage}
                toggle={() => setModalLanguege((state) => !state)}
              >
                <ModelLanguage
                  formData={formData}
                  setFormData={setFormData}
                  language_id={language_id}
                  setModalLanguege={setModalLanguege}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaldeliverables}
                toggle={() => setModaldeliverables((state) => !state)}
              >
                <ModelDeliverables
                  setFormData={setFormData}
                  deliverables={deliverables}
                  setModaldeliverables={setModaldeliverables}
                  handleInputExpecteddeliverables={
                    handleInputExpecteddeliverables
                  }
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalfile}
                toggle={() => setModalFile((state) => !state)}
              >
                <ModelFile
                  formData={formData}
                  setFormData={setFormData}
                  setModalFile={setModalFile}
                />
              </Modal>
              {/* <Modal
                className="popupmodal"
                isOpen={modalSkills}
                toggle={() => setModalSkills((state) => !state)}
              >
                <ModelSkills
                  formData={formData}
                  setFormData={setFormData}
                  setModalSkills={setModalSkills}
                />
              </Modal> */}
              <Modal
                className="popupmodal"
                isOpen={modalMils}
                toggle={() => setModalMils((state) => !state)}
              >
                <ModelMilestones
                  formData={formData}
                  setFormData={setFormData}
                  setModalMils={setModalMils}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaltype}
                toggle={() => setModaltype((state) => !state)}
              >
                <ModelType
                  formData={formData}
                  setFormData={setFormData}
                  setModaltype={setModaltype}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalhiringtype}
                toggle={() => setModalhiringtype((state) => !state)}
              >
                <ModelWorkHiringType
                  formData={formData}
                  setFormData={setFormData}
                  setModalhiringtype={setModalhiringtype}
                />
              </Modal>

              <Modal
                className="popupmodal"
                isOpen={modalcountry}
                toggle={() => setModalcountry((state) => !state)}
              >
                <ModelCountry
                  formData={formData}
                  setFormData={setFormData}
                  category={category}
                  setModalcountry={setModalcountry}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalcity}
                toggle={() => setModalcity((state) => !state)}
              >
                <ModalCity
                  cityname={cityname}
                  setModalcity={setModalcity}
                  handleCityInputTitle={handleCityInputTitle}
                  hitApi={hitApi}
                />
              </Modal>

              <Modal
                className="popupmodal"
                isOpen={industryEditModal}
                toggle={() => setIndustryEditModal((state) => !state)}
              >
                <ModalIndustry
                  formData={formData}
                  setFormData={setFormData}
                  setIndustryEditModal={setIndustryEditModal}
                />
              </Modal>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default UpdateHireExpertJobDetails;
